import { ReactNode } from "react";

export interface IWrapperContentProps {
  children: ReactNode;
}

export function WrapperContent({ children }: IWrapperContentProps) {
  return (
    <div className="w-full px-4 md:px-5 lg:md:px-6 box-border">{children}</div>
  );
}
